// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__Z+q66","mobile":"style_mobile__3hEKS","laptop":"style_laptop__YPFkI","v3":"style_v3__cDsCa","status":"style_status__kY0BF","id":"style_id__qHcmI"};